import { render, staticRenderFns } from "./OriginList.vue?vue&type=template&id=37b93ea4"
import script from "./OriginList.vue?vue&type=script&lang=js"
export * from "./OriginList.vue?vue&type=script&lang=js"
import style0 from "./OriginList.vue?vue&type=style&index=0&id=37b93ea4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports